module.exports = __webpack_public_path__ + "static/media/素紅糟肉.6faadeff.jpg";